// extracted by mini-css-extract-plugin
module.exports =  {"header":"_02712f2b3b--header--PCyut","counter":"_02712f2b3b--counter--j1yat","content":"_02712f2b3b--content--gFhtt","close_button":"_02712f2b3b--close_button--dvuSM"};